export const isFrameCollectionCurrent = (generationRef, generation) =>
  generationRef.current === generation;

export const stopFrameCollection = ({
  intervalRef,
  generationRef,
  clearIntervalFn = clearInterval,
  discard,
}) => {
  generationRef.current += 1;
  if (intervalRef.current !== null) {
    clearIntervalFn(intervalRef.current);
    intervalRef.current = null;
  }
  discard?.();
};

export const startFrameCollection = ({
  intervalRef,
  generationRef,
  tick,
  intervalMs,
  setIntervalFn = setInterval,
  clearIntervalFn = clearInterval,
  discard,
}) => {
  stopFrameCollection({ intervalRef, generationRef, clearIntervalFn, discard });
  const generation = generationRef.current;
  intervalRef.current = setIntervalFn(() => {
    if (isFrameCollectionCurrent(generationRef, generation)) {
      tick(generation);
    }
  }, intervalMs);
  return generation;
};
